/* eslint-disable no-mixed-spaces-and-tabs,no-param-reassign,no-tabs,@typescript-eslint/no-unused-expressions,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define,no-var,vars-on-top */

import { EVENTS } from '../../../../../app/constants/events';

xplenty.directive('googleAdsObjectPicker', [
  '$rootScope',
  '$timeout',
  '$http',
  '$stateParams',
  'connectionsService',
  '$translate',
  'ConnectionItemsResource',
  function ($rootScope, $timeout, $http, $stateParams, connectionsService, $translate, ConnectionItemsResource) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./google-ads-object-picker.html'),

      replace: true,

      controller: [
        '$scope',
        function ($scope) {
          $scope.objectNameOptions = [];
          $scope.objectsAndFields = [];

          let lastObjectName;

          $scope.loadObjects = function () {
            if ($scope.component.connection && $scope.component.connection.type && $scope.component.connection.id) {
              $scope.loadingObjects = true;
              if ($scope.componentFormStep) {
                $scope.componentFormStep.loading = true;
              }

              $http
                .get(`${process.env.API_URL}/ads/AdsV10.json`)
                .then(function successCallback(response) {
                  const objectsAndFields = response.data;
                  if ($scope.componentFormStep) {
                    $scope.componentFormStep.loading = false;
                  }
                  if ($scope.component.object_name) {
                    lastObjectName = $scope.component.object_name;
                  }

                  $scope.objectNameOptions = objectsAndFields.map((entity) => ({
                    text: entity.name,
                    value: entity.name,
                  }));
                  $scope.objectsAndFields = objectsAndFields;
                  $scope.loadingObjects = false;
                  if (lastObjectName) {
                    $scope.component.object_name = lastObjectName;
                    $scope.errorMessage = null;
                  } else if (lastObjectName) {
                    $scope.errorMessage = $translate.instant('google-ads-destination-editor.form.errors.object_name', {
                      objectName: lastObjectName,
                    });
                  } else {
                    $scope.errorMessage = null;
                  }
                  loadFields();
                })
                .catch(function errorCallback(response) {
                  $scope.loadingObjects = false;
                  $scope.errorMessage = response.error.error_message;
                });
            }
          };

          $scope.isFirstRun = true;

          $scope.$watch('component.connection.type', function () {
            $scope.loadObjects();
          });

          $scope.loadingObjects = false;
          $scope.errorMessage = null;

          const loadFields = function () {
            if (
              $scope.component.connection &&
              $scope.component.connection.type &&
              $scope.component.object_name &&
              $scope.component.object_name !== ''
            ) {
              const foundObject =
                $scope.objectsAndFields.find((obj) => obj.name === $scope.component.object_name) || {};
              $rootScope.$broadcast(EVENTS.GOOGLE_ADS_OBJECT_PICKER_FIELDS_LOADED, foundObject.fields || []);
            }
          };

          $scope.onObjectNameChange = (objectName) => {
            $scope.component.object_name = objectName;
            $scope.errorMessage = null;
            $rootScope.$broadcast(EVENTS.GOOGLE_ADS_OBJECT_PICKER_FIELDS_LOAD_START);
            loadFields();
          };

          loadFields();

          $scope.$on(EVENTS.SCHEMA_IMPORTER_LOADING_STARTED, function () {
            loadFields();
          });
        },
      ],
    };
  },
]);
